import { searchParamsToString, } from '@moderepo/mode-data-state-base';
/**
 * Get the event logs data for the given homeId, logSourcePath, and filters used when fetching the data
 * @param state
 * @param homeId
 * @param logSourcePath
 * @param filters
 */
export const selectEventLogs = (state, homeId, logSourcePath, filters) => {
    var _a, _b;
    const searchParams = searchParamsToString(filters);
    return (_b = (_a = state.eventLogsState.eventLogDataByHomeIdByLogResourcePathBySearchParams[homeId]) === null || _a === void 0 ? void 0 : _a[logSourcePath]) === null || _b === void 0 ? void 0 : _b[searchParams];
};
